// src/pages/LivePayment.js — หน้าจ่ายเงินออเดอร์ไลฟ์ (public, cf_engine_v1)
// ลูกค้าเปิดจากลิงก์ในแชท: /live/pay/:id → ดู QR + อัปสลิป → slip2go auto-verify
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { QRCodeSVG } from 'qrcode.react';

const money = (n) => Number(n || 0).toLocaleString('en-US');
const wrap = { maxWidth: 440, margin: '0 auto', padding: 16, fontFamily: 'system-ui, sans-serif', color: '#0f172a' };
const card = { background: '#fff', border: '1px solid #e2e8f0', borderRadius: 16, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,.06)' };

export default function LivePayment() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null); // {paid, reason}

  const load = () => {
    fetch('/api/public/live/pay/' + encodeURIComponent(id))
      .then((r) => r.json())
      .then((d) => { if (d.error) setErr(d.error); else setData(d); })
      .catch(() => setErr('โหลดข้อมูลไม่สำเร็จ'));
  };
  useEffect(load, [id]);

  const onFile = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) { setResult({ paid: false, reason: 'ไฟล์ใหญ่เกิน 5MB' }); return; }
    const reader = new FileReader();
    reader.onload = () => upload(reader.result);
    reader.readAsDataURL(file);
  };

  const upload = (image_base64) => {
    setBusy(true); setResult(null);
    fetch('/api/public/live/pay/' + encodeURIComponent(id) + '/slip', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ image_base64, amount: data.order.total }),
    })
      .then((r) => r.json())
      .then((d) => {
        if (d.error) { setResult({ paid: false, reason: d.error }); }
        else if (d.auto && d.auto.paid) { setResult({ paid: true }); load(); }
        else { setResult({ paid: false, reason: (d.auto && d.auto.reason) || 'ได้รับสลิปแล้ว รอร้านตรวจสอบ' }); }
      })
      .catch(() => setResult({ paid: false, reason: 'อัปโหลดไม่สำเร็จ' }))
      .finally(() => setBusy(false));
  };

  if (err) return <div style={wrap}><div style={card}>❌ {err}</div></div>;
  if (!data) return <div style={wrap}><div style={card}>กำลังโหลด…</div></div>;

  const paid = data.order.status === 'paid';

  return (
    <div style={wrap}>
      <div style={{ textAlign: 'center', margin: '12px 0 16px', fontWeight: 700, fontSize: 18 }}>{data.shop || 'ร้านค้า'}</div>
      <div style={card}>
        <div style={{ fontSize: 13, color: '#64748b' }}>ออเดอร์ #{String(id).slice(0, 8).toUpperCase()}</div>
        <div style={{ margin: '12px 0', borderTop: '1px dashed #e2e8f0', paddingTop: 12 }}>
          {data.items.map((it) => (
            <div key={it.code} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 14, marginBottom: 6 }}>
              <span>{it.code} {it.name} ×{it.qty}</span>
              <span>{money(it.unit_price * it.qty)}</span>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 700, fontSize: 18, borderTop: '1px solid #e2e8f0', paddingTop: 12 }}>
          <span>รวม</span><span>{money(data.order.total)} บาท</span>
        </div>
      </div>

      {paid ? (
        <div style={{ ...card, marginTop: 16, textAlign: 'center', borderColor: '#16a34a', background: '#f0fdf4' }}>
          <div style={{ fontSize: 40 }}>✅</div>
          <div style={{ fontWeight: 700, fontSize: 18, color: '#15803d' }}>ชำระเงินเรียบร้อยแล้ว</div>
          <div style={{ fontSize: 13, color: '#64748b', marginTop: 4 }}>ขอบคุณค่ะ ร้านจะจัดส่งให้เร็วที่สุด</div>
        </div>
      ) : (
        <div style={{ ...card, marginTop: 16, textAlign: 'center' }}>
          {data.qr_payload ? (
            <>
              <div style={{ fontWeight: 600, marginBottom: 8 }}>📲 สแกนพร้อมเพย์เพื่อจ่าย</div>
              <div style={{ display: 'inline-block', padding: 12, background: '#fff', border: '1px solid #e2e8f0', borderRadius: 12 }}>
                <QRCodeSVG value={data.qr_payload} size={220} level="M" />
              </div>
              <div style={{ fontSize: 14, marginTop: 8 }}>ยอด {money(data.order.total)} บาท{data.receiver.name ? ' → ' + data.receiver.name : ''}</div>
            </>
          ) : (
            <div style={{ color: '#b91c1c' }}>ร้านยังไม่ได้ตั้งค่าบัญชีรับเงิน</div>
          )}

          <div style={{ borderTop: '1px dashed #e2e8f0', margin: '16px 0', paddingTop: 16 }}>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>โอนแล้ว? อัปสลิปที่นี่</div>
            <label style={{ display: 'inline-block', padding: '12px 20px', background: '#2563eb', color: '#fff', borderRadius: 10, fontWeight: 600, cursor: 'pointer', opacity: busy ? 0.6 : 1 }}>
              {busy ? 'กำลังตรวจสอบ…' : '📎 เลือกรูปสลิป'}
              <input type="file" accept="image/*" onChange={onFile} disabled={busy} style={{ display: 'none' }} />
            </label>
          </div>

          {result && (
            <div style={{ marginTop: 8, padding: 12, borderRadius: 10, fontSize: 14, background: result.paid ? '#f0fdf4' : '#fef2f2', color: result.paid ? '#15803d' : '#b91c1c' }}>
              {result.paid ? '✅ ยืนยันการชำระเงินสำเร็จ!' : '⏳ ' + result.reason}
            </div>
          )}
        </div>
      )}
      <div style={{ textAlign: 'center', fontSize: 11, color: '#94a3b8', marginTop: 16 }}>ระบบตรวจสลิปอัตโนมัติ • ปลอดภัย</div>
    </div>
  );
}
